"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));

var _i18next = _interopRequireDefault(require("i18next"));

var _de_DE = _interopRequireDefault(require("./locales/de_DE.json"));

var _en_GB = _interopRequireDefault(require("./locales/en_GB.json"));

var _fr_FR = _interopRequireDefault(require("./locales/fr_FR.json"));

var _es_ES = _interopRequireDefault(require("./locales/es_ES.json"));

var _it_IT = _interopRequireDefault(require("./locales/it_IT.json"));

var _el_GR = _interopRequireDefault(require("./locales/el_GR.json"));

var _tr_TR = _interopRequireDefault(require("./locales/tr_TR.json"));

var _nl_NL = _interopRequireDefault(require("./locales/nl_NL.json"));

var _ru_RU = _interopRequireDefault(require("./locales/ru_RU.json"));

var _en_CA = _interopRequireDefault(require("./locales/en_CA.json"));

var _es_CL = _interopRequireDefault(require("./locales/es_CL.json"));

var _es_CO = _interopRequireDefault(require("./locales/es_CO.json"));

var _es_MX = _interopRequireDefault(require("./locales/es_MX.json"));

var _pt_BR = _interopRequireDefault(require("./locales/pt_BR.json"));

var _pl_PL = _interopRequireDefault(require("./locales/pl_PL.json"));

var _sv_SE = _interopRequireDefault(require("./locales/sv_SE.json"));

var _en_US = _interopRequireDefault(require("./locales/en_US.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = _i18next.default.createInstance();

instance.use(_i18nextBrowserLanguagedetector.default);
instance.init({
  // we init with resources
  resources: {
    en: _en_GB.default,
    us: _en_US.default,
    ca: _en_CA.default,
    de: _de_DE.default,
    fr: _fr_FR.default,
    it: _it_IT.default,
    el: _el_GR.default,
    tr: _tr_TR.default,
    nl: _nl_NL.default,
    ru: _ru_RU.default,
    es: _es_ES.default,
    cl: _es_CL.default,
    co: _es_CO.default,
    mx: _es_MX.default,
    br: _pt_BR.default,
    pl: _pl_PL.default,
    se: _sv_SE.default
  },
  fallbackLng: 'de',
  // have a common namespace used around the full app
  ns: ['subjects'],
  defaultNS: 'subjects',
  keySeparator: true,
  // we use content as keys
  // eslint-disable-next-line no-unused-vars
  parseMissingKeyHandler: function parseMissingKeyHandler(key) {
    return undefined;
  },
  interpolation: {
    escapeValue: false,
    // not needed for react!!
    formatSeparator: ','
  },
  detection: {
    lookupCookie: 'gslng',
    lookupLocalStorage: 'gslng'
  }
});
var _default = instance;
exports.default = _default;